'use client'

import type { ClientWapiService } from '@/services/auth/client/wapi-service'

import { useClientEnv } from './use-client-env'

/**
 * Hook to access the client WAPI service from React components.
 *
 * Returns a non-null `ClientWapiService` — the user-token-bearing, client-direct
 * WAPI surface (federated exchange, refresh, identify, getUserInfo, logout).
 * Call its methods from `useEffect` or an event handler, never the render body
 * (the SSR sentinel / no-env-services-in-render guard the latter).
 *
 * @throws Error if used outside ClientEnvProvider
 *
 * @example
 * ```tsx
 * function LogoutButton() {
 *   const wapi = useWapi()
 *   const onClick = () => void wapi.logout(token)
 *   return <button onClick={onClick}>Log out</button>
 * }
 * ```
 */
export function useWapi(): ClientWapiService {
    return useClientEnv().services.wapi
}
